'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cssElementQueries = require('css-element-queries');

var _ui = require('../constants/events/ui');

var _ui2 = _interopRequireDefault(_ui);

var _ui3 = require('./ui.view');

var _ui4 = _interopRequireDefault(_ui3);

var _overlay = require('./overlay/overlay.controler');

var _overlay2 = _interopRequireDefault(_overlay);

var _controls = require('./controls/controls.controler');

var _controls2 = _interopRequireDefault(_controls);

var _loader = require('./loader/loader.controler');

var _loader2 = _interopRequireDefault(_loader);

var _screen = require('./screen/screen.controler');

var _screen2 = _interopRequireDefault(_screen);

var _fullScreen = require('../full-screen/full-screen');

var _fullScreen2 = _interopRequireDefault(_fullScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_CONFIG = {
  overlay: false,
  customUI: {}
};

var PlayerUI = function () {
  function PlayerUI(_ref) {
    var engine = _ref.engine,
        eventEmitter = _ref.eventEmitter,
        config = _ref.config;

    _classCallCheck(this, PlayerUI);

    this._eventEmitter = eventEmitter;
    this._engine = engine;
    this.config = _extends({}, DEFAULT_CONFIG, config);
    this.isHidden = false;

    this._bindCallbacks();
    this._initUI();

    this._initComponents();
    this._initCustomUI();

    this._bindEvents();

    _cssElementQueries.ElementQueries.listen();

    this._fullScreen = new _fullScreen2.default({
      eventEmitter: this._eventEmitter,
      engine: this._engine,
      ui: this
    });
  }

  _createClass(PlayerUI, [{
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._proxyMouseEnter = this._proxyMouseEnter.bind(this);
      this._proxyMouseMove = this._proxyMouseMove.bind(this);
      this._proxyMouseLeave = this._proxyMouseLeave.bind(this);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_ui2.default.FULLSCREEN_STATUS_CHANGED, this.view.setFullScreenStatus, this.view);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_ui2.default.FULLSCREEN_STATUS_CHANGED, this.view.setFullScreenStatus, this.view);
    }
  }, {
    key: '_initUI',
    value: function _initUI() {
      var _config = this.config,
          width = _config.width,
          height = _config.height;

      var config = {
        width: width,
        height: height,
        callbacks: {
          onMouseEnter: this._proxyMouseEnter,
          onMouseMove: this._proxyMouseMove,
          onMouseLeave: this._proxyMouseLeave
        }
      };

      this.view = new _ui4.default(config);
    }
  }, {
    key: '_initComponents',
    value: function _initComponents() {
      this._initOverlay();

      this._initLoader();

      this._initScreen();

      this._initControls();
    }
  }, {
    key: '_initScreen',
    value: function _initScreen() {
      this.screen = new _screen2.default({
        config: this.config.screen,
        engine: this._engine,
        ui: this,
        eventEmitter: this._eventEmitter
      });

      this.view.appendComponentNode(this.screen.node);
    }
  }, {
    key: '_initOverlay',
    value: function _initOverlay() {
      var config = this.config.overlay;

      if (config === false) {
        return;
      }

      if (typeof config === 'function') {
        this.overlay = new config({
          engine: this._engine,
          eventEmitter: this._eventEmitter,
          ui: this
        });

        this.view.appendComponentNode(this.overlay.getNode());
      } else {
        this.overlay = new _overlay2.default({
          engine: this._engine,
          eventEmitter: this._eventEmitter,
          config: this.config.overlay,
          ui: this
        });

        this.view.appendComponentNode(this.overlay.node);
      }
    }
  }, {
    key: '_initLoader',
    value: function _initLoader() {
      var config = this.config.loader;

      if (config === false) {
        return;
      }

      this.loader = new _loader2.default({
        engine: this._engine,
        eventEmitter: this._eventEmitter,
        config: this.config.loader,
        ui: this
      });

      this.view.appendComponentNode(this.loader.node);
    }
  }, {
    key: '_initControls',
    value: function _initControls() {
      var config = this.config.controls;

      if (config === false) {
        return;
      }

      this.controls = new _controls2.default({
        engine: this._engine,
        eventEmitter: this._eventEmitter,
        ui: this,
        config: config
      });

      this.screen.view.appendComponentNode(this.controls.node);
    }
  }, {
    key: '_initCustomUI',
    value: function _initCustomUI() {
      var _this = this;

      this.customComponents = {};
      var keys = Object.keys(this.config.customUI);
      keys.forEach(function (key) {
        var component = new _this.config.customUI[key]({
          engine: _this._engine,
          eventEmitter: _this._eventEmitter,
          ui: _this
        });

        _this.customComponents[key] = component;

        _this.screen.view.appendComponentNode(component.getNode());
      });
    }
  }, {
    key: '_proxyMouseEnter',
    value: function _proxyMouseEnter() {
      this._eventEmitter.emit(_ui2.default.MOUSE_ENTER_ON_PLAYER_TRIGGERED);
    }
  }, {
    key: '_proxyMouseMove',
    value: function _proxyMouseMove() {
      this._eventEmitter.emit(_ui2.default.MOUSE_MOVE_ON_PLAYER_TRIGGERED);
    }
  }, {
    key: '_proxyMouseLeave',
    value: function _proxyMouseLeave() {
      this._eventEmitter.emit(_ui2.default.MOUSE_LEAVE_ON_PLAYER_TRIGGERED);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.isHidden = true;
      this.view.hide();
    }
  }, {
    key: 'show',
    value: function show() {
      this.isHidden = false;
      this.view.show();
    }
  }, {
    key: 'setWidth',
    value: function setWidth(width) {
      this.view.setWidth(width);
    }
  }, {
    key: 'setHeight',
    value: function setHeight(height) {
      this.view.setHeight(height);
    }
  }, {
    key: 'enterFullScreen',
    value: function enterFullScreen() {
      this._fullScreen.enterFullScreen();
    }
  }, {
    key: 'exitFullScreen',
    value: function exitFullScreen() {
      this._fullScreen.exitFullScreen();
    }
  }, {
    key: 'isInFullScreen',
    value: function isInFullScreen() {
      return this._fullScreen.isInFullScreen;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();

      if (this.controls) {
        this.controls.destroy();
        delete this.controls;
      }

      if (this.screen) {
        this.screen.destroy();
        delete this.screen;
      }

      if (this.overlay) {
        this.overlay.destroy();
        delete this.overlay;
      }

      if (this.loader) {
        this.loader.destroy();
        delete this.loader;
      }

      this.view.destroy();
      delete this.view;

      this._fullScreen.destroy();
      delete this._fullScreen;

      delete this._eventEmitter;
      delete this._engine;
      delete this.config;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return PlayerUI;
}();

exports.default = PlayerUI;
//# sourceMappingURL=ui.controler.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/ui.controler.js
// module id = 1705
// module chunks = 1 2 3